import {
	clearSelectedAccountant,
	clearSelectedClient,
	clearSelectedTaxYear,
} from "../../../store/actions";

import { EarningsRoutesComponent } from "./EarningsRoutes";
import { MiscellaneousRoutesComponent } from "./MiscellaneousRoutes";
import { RoleManagementRoutesComponent } from "./RoleManagementRoutes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AdminRoutesComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { MiscellaneousRoutes } = MiscellaneousRoutesComponent();
	const { EarningsRoutes } = EarningsRoutesComponent();
	const { RoleManagementRoutes } = RoleManagementRoutesComponent();

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		// dispatch(clearSelectedClientName());
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		// dispatch(clearSelectedAccountantName());
		dispatch(clearSelectedAccountant());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const ArrayData = [
		{
			label: "Home",
			expanded: true,
			// icon: <HomeOutlinedIcon />,
			items: [
				{
					label: "Global Search",
					command: () => {
						navigate("/global-search");
						clearClientId();
						clearClientName();
						clearAccountantId();
						clearAccountantName();
						clearTaxYear();
						// clearRefNo();
					},
				},
			],
		},
		{
			label: "Accountant",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/accountants/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/accountants/setup");
					},
				},
				{
					label: "Bank",
					command: () => {
						navigate("/accountants/bank-setup");
					},
				},
			],
		},
		{
			label: "Misc.",
			items: MiscellaneousRoutes,
		},
		{
			label: "Earnings",
			items: EarningsRoutes,
		},
		{
			label: "Role Management",
			items: RoleManagementRoutes,
		},
	];
	return {
		AdminRoutes: ArrayData,
	};
};
